export default __webpack_public_path__ + "static/media/Q3-2.5d834e8b.png";